import React, { useEffect } from 'react'
import PageHeader from '../../PageHeader/PageHeader'
import { HitApi } from '../../Api/ApiHit'
import { deleteTask, searchTask, triggerMonthlyTask } from '../../constant/Constant'
import { useDispatch, useSelector } from 'react-redux';
import AppTable from '../../components/AppTable/AppTable';
import EditButton from '../../components/Edit/EditButton';
import DeleteButton from '../../components/Delete/DeleteButton';
import { setApiJson } from '../../redux/Actions/ApiAction';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { getSelectedUnit } from '../../storage/Storage';
import MongoosePagination from '../../components/Pagination/MongoosePagination';
import { setPagination } from '../../redux/Actions/TableAction';
import { ActionIcon, Tooltip } from 'rizzui';
import { PlayIcon } from '@heroicons/react/24/outline';

function TaskMaster() {
    const ApiReducer = useSelector((state) => state.ApiReducer);
    const TableDataReducer = useSelector((state) => state.TableReducer);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    useEffect(() => {
        getTasks()
    }, [TableDataReducer.pagination.page, TableDataReducer.pagination.limi])

    const getTasks = () => {
        var json = {
            page: TableDataReducer.pagination.page,
            limit: TableDataReducer.pagination.limit,
            search: {
                unitIds: getSelectedUnit()?._id,
            }
        }
        HitApi(json, searchTask).then((res) => {



            const paginationData = {
                total: res?.data?.totalDocs || 0,
                page: TableDataReducer.pagination.page,
                limit: TableDataReducer.pagination.limit,
            };

            dispatch(setPagination(paginationData))



            if (res?.statusCode === 200) {
                const taskData = Array.isArray(res.data.docs) ? res.data.docs : [];
                dispatch(setApiJson(taskData));
            } else if (res?.message === "Tasks retrieved successfully") {
                const taskData = Array.isArray(res?.data?.docs) ? res?.data?.docs : [];
                dispatch(setApiJson(taskData));
            }
        }).catch(error => {
            console.error("Error fetching tasks:", error);
            toast.error("Failed to fetch tasks");
        })
    }

    const formatDateTime = (timestamp) => {
        if (!timestamp) return 'Not set';

        const date = new Date(timestamp);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }) + ', ' + date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const formatTimeIntervals = (taskIntervals) => {
        if (!Array.isArray(taskIntervals) || taskIntervals.length === 0) {
            return [];
        }

        return taskIntervals.map(interval => {
            const startDate = new Date(interval.start);
            const endDate = new Date(interval.end);

            const startTime = startDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
            const endTime = endDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });

            return {
                time: `${startTime}-${endTime}`,
                interval: interval.interval,
                status: interval.status
            };
        });
    };

    const getPriorityColor = (priority) => {
        switch (priority?.toLowerCase()) {
            case 'high':
                return { bg: 'bg-red-100', text: 'text-red-700' };
            case 'medium':
                return { bg: 'bg-yellow-100', text: 'text-yellow-700' };
            case 'low':
                return { bg: 'bg-green-100', text: 'text-green-700' };
            default:
                return { bg: 'bg-gray-100', text: 'text-gray-700' };
        }
    };

    const getFrequencyBadgeColor = (frequency) => {
        switch (frequency?.toLowerCase()) {
            case 'once':
                return 'bg-blue-100 text-blue-700';
            case 'daily':
                return 'bg-green-100 text-green-700';
            case 'weekly':
                return 'bg-purple-100 text-purple-700';
            case 'monthly':
                return 'bg-orange-100 text-orange-700';
            default:
                return 'bg-gray-100 text-gray-700';
        }
    };

    const formatWeekDay = (day) => {
        console.log("day", day);
        if (!day) return '';

        // If it's already a day name, convert to uppercase
        if (isNaN(day)) {
            return day.toUpperCase();
        }

        // If it's a number, convert to day name
        const dayNames = {
            '1': 'Monday',
            '2': 'Tuesday',
            '3': 'Wednesday',
            '4': 'Thursday',
            '5': 'Friday',
            '6': 'Saturday',
            '7': 'Sunday'
        };

        return dayNames[day] || day;
    };

    const formatWeekNumber = (weekNum) => {


        if (!weekNum) return '';
        return `Week ${weekNum}`;
    };

    const baseIndex = (TableDataReducer?.pagination?.page - 1) * TableDataReducer?.pagination?.limit || 0;

    const baseTableHeaders = [
        {
            title: "S.No",
            key: "serialNumber",
            width: "60px",
            align: "center",
            render: (_, row, index) => {
                const serialNumber = baseIndex + index + 1;
                return <span className="text-sm font-medium">{serialNumber}</span>;
            }
        },
        {
            title: "Task Details",
            key: "taskName",
            width: "220px",
            render: (value, row) => (
                <div className="space-y-2">
                    <div className="font-medium text-sm text-gray-900" title={value}>
                        {value || 'Unnamed Task'}
                    </div>
                    <div className="text-xs text-gray-600 line-clamp-2" title={row.description}>
                        {row.description || 'No description'}
                    </div>
                    <div className="flex flex-wrap gap-1">
                        {row.priority && (
                            <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(row.priority).bg} ${getPriorityColor(row.priority).text}`}>
                                {row.priority.charAt(0).toUpperCase() + row.priority.slice(1)}
                            </span>
                        )}
                        {row.taskFrequency && (
                            <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${getFrequencyBadgeColor(row.taskFrequency)}`}>
                                {row.taskFrequency.charAt(0).toUpperCase() + row.taskFrequency.slice(1)}
                            </span>
                        )}
                        {row.status && (
                            <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${(row.status || 'active') === 'active'
                                ? 'bg-green-100 text-green-700'
                                : 'bg-red-100 text-red-700'
                                }`}>

                                {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                            </span>
                        )}
                    </div>
                </div>
            )
        },
        {
            title: "Schedule Type & Timing",
            key: "scheduling",
            width: "250px",
            render: (value, row) => (
                <div className="space-y-2 w-full text-xs">
                    <div>
                        <span className="font-medium text-gray-700">Scheduled: </span>
                        <div className="text-gray-900 mt-1">{formatDateTime(row.scheduledDateTime)}</div>
                    </div>

                    <div>
                        <span className="font-medium text-gray-700">Duration: </span>
                        <div className="text-gray-900">
                            <div>Start: {formatDateTime(row.startDateTime)}</div>
                            <div>End: {formatDateTime(row.endDateTime)}</div>
                        </div>
                    </div>

                    {/* Week Days - Display as MONDAY, TUESDAY, etc. */}
                    {row.weekDays && row.weekDays.length > 0 && (
                        <div>
                            <span className="font-medium text-gray-700">Week Days: </span>
                            <div className="flex flex-wrap gap-1 mt-1">
                                {row.weekDays.map((day, index) => (
                                    <span key={index} className="bg-cyan-100 text-cyan-700 px-1 py-0.5 rounded text-xs font-medium">
                                        {formatWeekDay(day)}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Monthly Week Days - Display as MONDAY, TUESDAY, etc. */}
                    {row.weekDaysForMonthly && row.weekDaysForMonthly.length > 0 && (
                        <div>
                            <span className="font-medium text-gray-700">Monthly Days: </span>
                            <div className="flex flex-wrap gap-1 mt-1">
                                {row.weekDaysForMonthly.map((day, index) => (
                                    <span key={index} className="bg-pink-100 text-pink-700 px-1 py-0.5 rounded text-xs font-medium">
                                        {formatWeekDay(day)}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Month Weeks - Display as WEEK 1, WEEK 2, etc. */}
                    {row.monthWeeks && row.monthWeeks.length > 0 && (
                        <div>
                            <span className="font-medium text-gray-700">Month Weeks: </span>
                            <div className="flex flex-wrap gap-1 mt-1">
                                {row.monthWeeks.map((week, index) => (
                                    <span key={index} className="bg-teal-100 text-teal-700 px-1 py-0.5 rounded text-xs font-medium">
                                        {formatWeekNumber(week)}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )
        },
        {
            title: "Time Intervals",
            key: "taskIntervals",
            width: "200px",
            render: (value, row) => (
                <div className="space-y-1">
                    {row.taskIntervals && row.taskIntervals.length > 0 ? (
                        <div>
                            <div className="space-y-1">
                                {formatTimeIntervals(row.taskIntervals).map((item, index) => (
                                    <div key={index} className="bg-blue-50 p-1 rounded text-xs">
                                        <div className="font-mono text-blue-900">{item.time}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <span className="text-gray-400 text-xs italic">No time intervals</span>
                    )}
                </div>
            )
        },
        {
            title: "Role",
            key: "roleId",
            width: "120px",
            render: (value, row) => (
                <div>
                    {value && value.roleName ? (
                        <div className="text-sm font-medium text-gray-900">
                            {value.roleName}
                        </div>
                    ) : (
                        <span className="text-gray-400 text-xs italic">No role</span>
                    )}
                </div>
            )
        },
        {
            title: "Assigned To",
            key: "assignedTo",
            width: "150px",
            render: (value, row) => (
                <div>
                    {Array.isArray(value) && value.length > 0 ? (
                        <div className="space-y-1">
                            {value.map((user, index) => (
                                <div key={user._id || index} className="text-sm font-medium text-gray-900">
                                    {user.name || 'Unknown User'}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <span className="text-gray-400 text-xs italic">Not assigned</span>
                    )}
                </div>
            )
        },
    ];

    const tableHeaders = [
        ...baseTableHeaders,
        {
            title: "Actions",
            key: "actions",
            width: "120px",
            align: "center",
            render: (value, row) => {
                return (
                    <div className="flex justify-center items-center gap-2">
                        <span onClick={(e) => e.stopPropagation()}>
                            <Tooltip content="Initiate Task" placement="top">
                                <ActionIcon
                                    variant="outline"
                                    rounded="md"
                                    size="sm"
                                    className="border-gray-200"
                                    onClick={() => handleInitiateTask(row)}
                                >
                                    <PlayIcon className="w-4 h-4" />
                                </ActionIcon>
                            </Tooltip>
                        </span>
                        <EditButton
                            onEdit={() => handleEdit(row)}
                            itemName="task"
                        />
                        <DeleteButton
                            onDelete={() => handleDelete(row)}
                            itemName="task"
                        />
                    </div>
                );
            }
        }
    ];

    const handleEdit = (row) => {
        navigate(`/taskmanagement/edit/${row._id}`);
    };

    const handleDelete = (row) => {
        if (window.confirm(`Are you sure you want to delete "${row.taskName}"?`)) {
            const json = {
                _id: row?._id
            };
            HitApi(json, deleteTask).then((res) => {
                if (res?.statusCode === 200 || res?.status === 200) {
                    toast.success("Task deleted successfully");
                    getTasks();
                } else {
                    toast.error('Failed to delete Task. Please try again.');
                }
            }).catch(error => {
                console.error("Delete error:", error);
                toast.error("Error deleting task. Please try again.");
            });
        }
    };


    const handleInitiateTask = (row) => {
        const json = {
            taskId: row._id
        };

        HitApi(json, triggerMonthlyTask).then((res) => {
            console.log("Task Initiate Response:", res);
            if (res?.message === "Monthly task evidence creation triggered successfully" || res?.statusCode === 200 || res?.status === 200) {
                toast.success(`Task "${row.taskName}" initiated successfully`);
                getTasks(); // Refresh the task list
            } else {
                toast.error("Failed to initiate task");
            }
        }).catch(error => {
            console.error("Task initiate error:", error);
            toast.error("Error initiating task. Please try again.");
        });
    }

    return (
        <div className='p-5'>
            <PageHeader
                title={'Task Management'}
                description={'Complete task management with all available data fields'}
            />
            <AppTable
                TH={tableHeaders}
                TD={Array.isArray(ApiReducer.apiJson) ? ApiReducer.apiJson : []}
                buttonText="Add New Task"
                navigateTo="/taskmanagement/add"
                hidePagination={true}
            />
            <MongoosePagination />
        </div>
    )
}
export default TaskMaster